export var ModalWindowContainerTotalAccCard = {
    container: null,
    init: function (idDiv) {
        ModalWindowContainerTotalAccCard.container = document.querySelector('#'+idDiv);
        if (!ModalWindowContainerTotalAccCard.container) {
            ModalWindowContainerTotalAccCard.container = document.createElement('div');
            ModalWindowContainerTotalAccCard.container.id = idDiv;
            ModalWindowContainerTotalAccCard.container.hidden = true;
            document.body.appendChild(ModalWindowContainerTotalAccCard.container);

            m.mount(ModalWindowContainerTotalAccCard.container, m.component(ModalViewTotalAccCard, {title: ""}));
        }
    },
    open: function (srcdoc, idDiv=null) {
        if(ModalWindowContainerTotalAccCard.container === null)
            ModalWindowContainerTotalAccCard.container = document.querySelector('#'+idDiv);
        if (ModalWindowContainerTotalAccCard.container && srcdoc != null) {
            document.getElementById("srcIframe").srcdoc = srcdoc;
            ModalWindowContainerTotalAccCard.container.hidden = false;
            m.redraw.strategy("diff");
        }
    },
    close: function () {
        ModalWindowContainerTotalAccCard.container.hidden = true;
    }
};

var ModalViewTotalAccCard = {
    view: function (ctrl, args) {
        return [m("div.dm-overlay[id='']", [
            m("div.dm-table", [
                m("div.dm-cell", [
                    m("div.dm-modal[style='border: 0; width: 100%; max-width: 54em; ']", [
                        m(".bg-primary[style='padding:10px;z-index:1;']", [
                            m("span[style='padding-right: 20px;'][id='headerModalAccCard']", "Просмотр"),
                            m("span.pull-right[style='cursor: pointer;']", {
                                onclick: ModalWindowContainerTotalAccCard.close
                            }, [
                                m("i.glyphicon.glyphicon-remove"),
                                m.trust('&nbsp;Закрыть')
                            ])
                        ]),
                        [
                            m("div", [
                                m("div[style='margin: 15px 0; padding: 0 15px; width: 100%; height: auto; display: block; position: relative;']", [
                                    m("iframe[id='srcIframe'][allowfullscreen=''][style='border: 0; top:0px; left:0px; width: 100%;']", {
                                        onload: function (){
                                            var ifrm = document.getElementById(this.id);
                                            if(ifrm) {
                                                let doc = ifrm.contentDocument;
                                                this.height = doc.body.scrollHeight < window.innerHeight ? doc.body.scrollHeight : window.innerHeight;
                                                this.width = doc.body.scrollWidth < window.innerWidth ? doc.body.scrollWidth : window.innerWidth;
                                            }
                                        }
                                    }),
                                    m("br"),
                                    m(".row[style='text-align: center;']", [
                                        m("button.btn.btn-warning.btn-lg", {
                                            id: "",
                                            onclick: function () {
                                                ModalWindowContainerTotalAccCard.close();
                                            }
                                        }, "Ок")
                                    ]),
                                ])
                            ])
                        ]
                    ])
                ])
            ])
        ])];
    }
};
